export type Description = {
  fr: string;
  en: string;
};

export enum SeverityCodeEnum {
  WARNING = "WARNING",
  CRITICAL = "CRITICAL",
}

export type ErrorAndWarning = {
  moduleAddress: string;
  severityCode: SeverityCodeEnum;
  severity: Description;
  label: Description;
  doc: Description;
};

// export type AreaStateAggregateType = {
//   areaId: string;
//   isLocked: boolean;

//   actionInProgress: boolean;

//   errorsAndWarnings: ErrorAndWarning[];

//   numberOfModulesInArea: number;
//   numberOfUnderMaintenanceModules: number; //En maintenance

//   numberOfModulesWithMachineErrors: number;
//   numberOfModulesWithMachineWarnings: number;
//   numberOfFaultyModules: number;

//   numberOfWaitingForStateModules: number;

//   numberOfFoldedModules: number;
//   numberOfUnfoldedModules: number;

//   averageBattery: number;

//   percentageOfFaultyModules: number;
//   percentageOfWaitingForStateModules: number;
//   percentageOfFoldedModules: number;
//   percentageOfUnfoldedModules: number;
//   percentageOfUnderMaintenanceModules: number;

//   unfoldedModules: string[];
//   foldedModules: string[];
//   waitingForStateModules: string[];
//   faultyModules: string[];
//   underMaintenanceModules: string[];
// };

export type AreaStateAggregateType = {
  areaId: string;
  isLocked: boolean;
  actionInProgress: boolean;

  errorsAndWarnings: ErrorAndWarning[];

  numberOfModulesInArea: number;
  numberOfUnderMaintenanceModules: number; //En maintenance

  numberOfModulesWithMachineErrors: number;
  numberOfModulesWithMachineWarnings: number;
  numberOfFaultyModules: number;

  numberOfLockedModules: number;

  numberOfWaitingForStateModules: number;

  numberOfFoldedModules: number;
  numberOfUnfoldedModules: number;
  numberOfUpModules: number;

  averageBattery: number;

  percentageOfFaultyModules: number;
  percentageOfWaitingForStateModules: number;
  percentageOfFoldedModules: number;
  percentageOfUnfoldedModules: number;
  percentageOfUpModules: number;
  percentageOfUnderMaintenanceModules: number;

  unfoldedModules: string[];
  foldedModules: string[];
  upModules: string[];
  waitingForStateModules: string[];
  faultyModules: string[];
  underMaintenanceModules: string[];
  lockedModules: string[];
};
